import { Currency, CurrencyAmount, Percent, Token } from '@kodiak-finance/sdk-core'
import { CHAIN_IDS_TO_NAMES, isSupportedChain, SupportedChainId } from 'config/chains'
import { ParsedQs } from 'qs'

const NATIVE_CHAIN_ID = 'NATIVE'

export const getDurationFromDateMilliseconds = (start: Date): number => {
  return new Date().getTime() - start.getTime()
}

export const formatToDecimal = (
  intialNumberObject: Percent | CurrencyAmount<Token | Currency>,
  decimalPlace: number
): number => parseFloat(intialNumberObject.toFixed(decimalPlace))

export const getTokenAddress = (currency: Currency) => (currency.isNative ? NATIVE_CHAIN_ID : currency.address)

export const formatPercentInBasisPointsNumber = (percent: Percent): number => parseFloat(percent.toFixed(2)) * 100

export function getChainIdFromName(name: string) {
  const entry = Object.entries(CHAIN_IDS_TO_NAMES).find(([, n]) => n === name)
  return entry ? Number(entry[0]) : undefined
}

export function getParsedChainId(parsedQs?: ParsedQs) {
  const chain = parsedQs?.chain
  if (typeof chain !== 'string') return

  const id = getChainIdFromName(chain)
  return isSupportedChain(id) ? id : undefined
}

export function getChainNameFromId(id: number | string): string {
  return CHAIN_IDS_TO_NAMES[id as SupportedChainId] ?? ''
}

export function addChainToUrl(url: string | undefined, chainId: number | undefined): string {
  if (!url || !chainId || url === '#') {
    return url || ''
  }

  const chainName = getChainNameFromId(chainId)
  if (!chainName) {
    return url
  }

  if (url.includes(`chain=${chainName}`)) {
    return url
  }

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}chain=${chainName}`
}
